<template>
  <div class="col-xs-12 col-md-3">
    <form-group-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="options"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="setValue($event)"
      @change="setValue($event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import CampoEnum from "../../../../domain/protocolo/CampoEnum";
import ProtocoloEnum from "../../../../domain/protocolo/ProtocoloEnum";
import convenio from "../../../../mixins/protocolo/convenio";

export default {
  name: "c-protocolo-local-estagio",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  mixins: [convenio],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    options() {
      return [
        {
          value: "Centro Universitário Integrado - Centro",
          text: "Centro Universitário Integrado - Centro"
        },
        {
          value: "Centro Universitário Integrado - Campus",
          text: "Centro Universitário Integrado - Campus"
        },
        {
          value: "Centro Universitário Integrado - Serviços",
          text: "Centro Universitário Integrado - Serviços"
        },
        {
          value: "Outro",
          text: "Outro"
        }
      ];
    }
  },
  methods: {
    setValue(value) {
      this.$emit("input", value);
      this.$updateValuesConvenio();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/LocalEstagio.vue